import { createEntityAdapter } from '@ngrx/entity';
import { NewsletterEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<NewsletterEntityState>;

export const adapter = createEntityAdapter<NewsletterEntityState>({
  selectId: o => o.idNewsletter
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const newsletterFeatureKey = 'newsletter';
